import { ref } from 'vue'

const raw = localStorage.getItem('userInfo')
const userInfo = ref(raw ? JSON.parse(raw) : null)

export function useUser() {
  const setUser = (data) => {
    userInfo.value = {
      userId: data.userId,
      phone: data.phone,
      nickname: data.nickname,
      avatar: data.avatar,
      realName: data.realName,
      idCard: data.idCard,
    }
    localStorage.setItem('userInfo', JSON.stringify(userInfo.value))
  }

  const setTokens = (accessToken, refreshToken) => {
    localStorage.setItem('accessToken', accessToken)
    localStorage.setItem('refreshToken', refreshToken)
  }

  const logout = () => {
    userInfo.value = null
    localStorage.removeItem('accessToken')
    localStorage.removeItem('refreshToken')
    localStorage.removeItem('userInfo')
  }

  return { userInfo, setUser, setTokens, logout }
}
